import { type ReactNode } from 'react';
import { ComponentesNoTemaEscuro } from './ComponentesNoTemaEscuro';
import { PaginaPropria } from './PrintBlocks';

/** Uma seção do documento impresso, já com os blocos que a paginação empacota. */
export interface SecaoDoDocumento {
  id: string;
  label: string;
  intro: string;
  /**
   * Unidades atômicas da seção, na ordem. Cada uma cabe inteira numa folha,
   * salvo a que for maior que a folha (essa é fatiada nos cortes seguros).
   * Plano B da paginação: declarar a seção folha a folha, com cada item
   * envolvido em `PaginaPropria`.
   */
  blocos: ReactNode[];
}

/** O que o documento precisa de cada seção do registro (`sectionRegistry.tsx`). */
export interface SecaoDoRegistro {
  id: string;
  label: string;
  intro: string;
  render: () => ReactNode;
  /** Blocos atômicos da seção; sem eles, a seção inteira é um bloco só. */
  blocos?: () => ReactNode[];
}

/** Seção que recebe, ao fim, a página de componentes no tema escuro. */
export const SECAO_DAS_PAGINAS_DE_TEMA = 'cores';

/**
 * Monta as seções do documento a partir do mesmo registro que a tela usa:
 * não existe conteúdo que apareça só no documento, salvo a página que mostra
 * no tema escuro os componentes que a tela mostra no tema em vigor.
 */
export function montarSecoesDoDocumento(registro: SecaoDoRegistro[]): SecaoDoDocumento[] {
  return registro.map((secao) => {
    const blocos = secao.blocos ? secao.blocos() : [secao.render()];
    return {
      id: secao.id,
      label: secao.label,
      intro: secao.intro,
      blocos:
        secao.id === SECAO_DAS_PAGINAS_DE_TEMA ? [...blocos, ...blocosDasPaginasDeTema()] : blocos,
    };
  });
}

/**
 * Página de tema do documento, no fim de Cores: componentes reais no tema
 * escuro. As amostras dos três temas já estão na própria seção Cores (que no
 * papel mostra todos os temas, pelos valores lidos de tokens.css); aqui se vê
 * o tema escuro aplicado aos componentes.
 */
export function blocosDasPaginasDeTema(): ReactNode[] {
  return [
    <PaginaPropria key="componentes-escuro">
      <ComponentesNoTemaEscuro />
    </PaginaPropria>,
  ];
}
